"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.switchActive = exports.updateFailure = exports.updateSuccess = exports.updateRequest = exports.createFailure = exports.createSuccess = exports.createRequest = void 0;
const types = require("./types");
const createRequest = (workspaceName) => ({
    workspaceName,
    type: types.CREATE_REQUEST
});
exports.createRequest = createRequest;
const createSuccess = (workspace) => ({
    workspace,
    type: types.CREATE_SUCCESS
});
exports.createSuccess = createSuccess;
const createFailure = (errorMessage) => ({
    errorMessage,
    type: types.CREATE_FAILURE
});
exports.createFailure = createFailure;
const updateRequest = (workspaceId, attributes) => ({
    workspaceId,
    attributes,
    type: types.UPDATE_REQUEST
});
exports.updateRequest = updateRequest;
const updateSuccess = (workspaceId, workspace) => ({
    workspaceId,
    workspace,
    type: types.UPDATE_SUCCESS
});
exports.updateSuccess = updateSuccess;
const updateFailure = (errorMessage) => ({
    errorMessage,
    type: types.UPDATE_FAILURE
});
exports.updateFailure = updateFailure;
const switchActive = (workspaceId) => ({
    workspaceId,
    type: types.SWITCH_ACTIVE
});
exports.switchActive = switchActive;
//# sourceMappingURL=actions.js.map